(() => {
  const key = 'zinko-favourites-v1';
  const dialog = document.getElementById('zinko-favourites');
  if (!dialog) return;
  let favourites = [];
  const safeUrl = (value, image = false) => {
    try {
      const url = new URL(value, location.origin);
      if (url.protocol !== 'https:' && url.protocol !== 'http:') return '';
      if (image) return url.origin === location.origin || url.hostname === 'cdn.shopify.com' ? url.href : '';
      return url.origin === location.origin && url.pathname.startsWith('/products/') ? url.href : '';
    } catch { return ''; }
  };
  const read = () => {
    try {
      const value = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(value) ? value.filter(p => p && typeof p.id === 'string' && typeof p.title === 'string' && safeUrl(p.url)).slice(0,200) : [];
    } catch { return []; }
  };
  const sync = () => {
    document.querySelectorAll('[data-zinko-favourite]').forEach(button => {
      const selected = favourites.some(p => p.id === button.dataset.zinkoFavourite);
      button.hidden = false;
      button.setAttribute('aria-pressed', String(selected));
      button.setAttribute('aria-label', selected ? button.dataset.labelRemove : button.dataset.labelSave);
    });
    document.querySelectorAll('[data-favourites-open]').forEach(button => {
      button.hidden = false;
      const count = button.querySelector('[data-favourites-count]');
      count.textContent = favourites.length;
      count.hidden = !favourites.length;
    });
  };
  const render = () => {
    const list = dialog.querySelector('[data-favourites-list]');
    list.replaceChildren();
    dialog.querySelector('[data-favourites-empty]').hidden = favourites.length > 0;
    favourites.forEach(product => {
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = safeUrl(product.url);
      const image = document.createElement('img');
      image.src = safeUrl(product.image, true);
      image.alt = product.title;
      image.loading = 'lazy';
      const info = document.createElement('div');
      const title = document.createElement('span');
      title.textContent = product.title;
      const price = document.createElement('span');
      price.textContent = product.price || '';
      info.append(title, price);
      link.append(image, info);
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.textContent = '×';
      remove.dataset.favouritesRemove = product.id;
      remove.setAttribute('aria-label', dialog.dataset.removeLabel.replace('__TITLE__', product.title));
      item.append(link, remove);
      list.append(item);
    });
  };
  const persist = () => {
    try { localStorage.setItem(key, JSON.stringify(favourites)); } catch {}
    sync();
    if (dialog.open) render();
  };
  document.addEventListener('click', event => {
    const save = event.target.closest('[data-zinko-favourite]');
    if (save) {
      event.preventDefault();
      event.stopPropagation();
      const id = save.dataset.zinkoFavourite;
      if (favourites.some(p => p.id === id)) favourites = favourites.filter(p => p.id !== id);
      else favourites = [{id, title:save.dataset.productTitle, url:save.dataset.productUrl, image:save.dataset.productImage, price:save.dataset.productPrice}, ...favourites].slice(0,200);
      persist();
      return;
    }
    if (event.target.closest('[data-favourites-open]')) {
      render();
      dialog.showModal();
    }
    if (event.target.closest('[data-favourites-close]')) dialog.close();
    const remove = event.target.closest('[data-favourites-remove]');
    if (remove) {
      favourites = favourites.filter(p => p.id !== remove.dataset.favouritesRemove);
      persist();
      dialog.querySelector('[data-favourites-close]').focus();
    }
    if (event.target === dialog) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    }
  });
  window.addEventListener('storage', event => { if (event.key === key) { favourites = read(); sync(); if (dialog.open) render(); } });
  const observer = new MutationObserver(records => {
    if (records.some(record => Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches('[data-zinko-favourite]') || node.querySelector('[data-zinko-favourite]'))))) sync();
  });
  observer.observe(document.body, {childList:true, subtree:true});
  favourites = read();
  sync();
})();
